// src/api/index.ts
import { createRouter, createClient } from "react-safe-query";
import { authRouter } from "./routers/auth";
import { categoryRouter } from "./routers/category";
import { eventRouter } from "./routers/events";
import { keywordRouter } from "./routers/keyword";
import { mediaRouter } from "./routers/media";
import { ottRouter } from "./routers/ott";

export const appRouter = createRouter({
  auth: authRouter,
  event: eventRouter,
  media: mediaRouter,
  ott: ottRouter,
  category: categoryRouter,
  keyword: keywordRouter,
});

export const apiClient = createClient(appRouter);

export type AppRouter = typeof appRouter;
